export default "__VITE_ASSET__C2WLzNfx__"